import OrgGardener from 'scoreboard/organizations/organizations-gardener'
import _ from 'lodash'
import $ from 'jquery'
import i18n from 'scoreboard/components/i18n'
import Tooltip from 'scoreboard/components/tooltip'
import OrgMultiTreeSelector from 'scoreboard/organizations/org-multi-tree-selector'
import projects from 'scoreboard/projects/projects'
import Project from 'scoreboard/projects/project'
import SyncedItemTooltip from 'scoreboard/components/synced-item-tooltip'
import user from 'scoreboard/components/user'

function getViewOrgPermissions(projectId, groupId) {
	if (user.isBuiltInAdmin()) {
		return $.Deferred().resolve({maxPermission: true})
	}
	let url = `api/admin/groups/viewOrgPermissions?projectId=${projectId}`
	//#32118 if a group id is given, initialize with all the orgs in the projects
	//associated with the group
	if (!_.isNil(groupId)) {
		url += `&groupId=${groupId}`
	}
	return $.get(url)
}

function cacheViewOrgPermissions(cache, projectId, permissionData) {
	cache[projectId] = {
		modifiableViewOrgPermissionOrgIds: _.keyBy(permissionData.modifiableViewOrgPermissionOrgIds),
		modifiableCascadeViewOrgPermissionOrgIds: _.keyBy(permissionData.modifiableCascadeViewOrgPermissionOrgIds),
		maxPermission: !!permissionData.maxPermission
	}
}

const AdminOrgGardener = OrgGardener.extend({
	_resolveUrlSection: section => '',
	_onChangeProject: function(e) {
		let projectId = $(e.target).val()
		//whenever the project id changes, we need to first check if we need to
		//fetch the VOP for that project
		$.when(this.options._onChangeProject(projectId)).done(() => {
			OrgGardener.prototype._onChangeProject.apply(this, arguments)
		})
	}
})

var OrgPermissionsForm = OrgMultiTreeSelector.extend({

	// this.model is the Group

	className: 'multi-tree-selector org-permissions-form',

	createGardener: function() {
		//since the org permission form is in the admin section, user's aren't
		//forced to select a project first, in the event nothing is selected
		//we'll default the first one #27549
		let projectId =  _.isNil(this.projectId) ? projects.selectedOrFirstId()
			: this.projectId
		return new AdminOrgGardener({
			showProjectSelector: true,
			projectId,
			descendants:true,
			ordered:true,
			permissions: true,
			finderOptions: {
				type: 'light'
			},
			streamOptions: {
				projectId
			},
			_onChangeProject: projectId => {
				//if we don't have the VOP for this project, fetch and cache them
				if (_.isNil(this._viewOrgPermissionsByProjectId[projectId])) {
					this.gardener.insertLoadingDots()
					return getViewOrgPermissions(projectId).then(data => {
						cacheViewOrgPermissions(this._viewOrgPermissionsByProjectId, projectId, data)
					})
				}
				return null
			}
		})
	},

	/**
	 *
	 * @param {Number|String} options.projectId will be converted to a number
	 */
	initialize: function(options = {}) {
		OrgMultiTreeSelector.prototype.initialize.apply(this, arguments)

		// #28990 prevent user from adding orgs they do not have permissions for
		this.options = _.extend(options, {
			treeActions : {
				itemPermissible: data => this.canModifyViewOrgPermission(data)
			}
		})
		this._previousSelections = _.cloneDeep(this.model.getOrgPermissions())
		this.on('done', this.onSubmit.bind(this))
		this._projectsById = _.mapValues(
			_.keyBy(this.model.get('projects'), 'id'),
			p => new Project(p))

		//store the view permission by projectId
		this._viewOrgPermissionsByProjectId = {}
		cacheViewOrgPermissions(this._viewOrgPermissionsByProjectId, this.options.projectId,
			this.options.viewOrgPermissions)
	},

	render: function() {
		OrgMultiTreeSelector.prototype.render.apply(this, arguments)
		if (_.some(this.model.get('orgPermissions'), o => o.view === false)) {
			this.$('.banner-description')
				.html(i18n.get('common.organization.noPermissionToSome'))
				.removeClass('is-not-displayed')
		}
	},

	oldSelections: function() {
		return this._previousSelections
	},

	context: function() {
		var title
		if (this.model.isNew()) {
			title = i18n.get('admin.group.newGroup')
		} else {
			title = this.model.get('label')
		}
		title += ': ' + i18n.get('admin.group.organizationPermissions')
		return {
			title: title,
			treeIcon: 'browse',
			treeIconClass: 'icon-browse',
			treeLabel: i18n.get('common.organization.organizations'),
			selectedLabel: i18n.get('report.metricComparisonReport.selectedOrganizations'),
			noneSelectedKey: 'admin.group.organizationPermissions.none',
			emptyTreeMessage: i18n.get('common.organization.noOrganizations'),
			cascadeHelpKey: 'admin.group.organizationPermissions.cascade.help',
			submitLabel: i18n.get('common.done')
		}
	},

	/**
	 * @override
	 */
	rowTemplate: function(ctx) {
		const disableCascade = (msgCode) => {
			row.find('.cascade input').prop('disabled', true)
			let self = this
			row.find('.cascade svg').on('click', function () {
				self.removeDisabledTooltip()
				self.disabledTooltip = new Tooltip({
					attachTo: this,
					placement: 'above',
					arrow: 'center',
					content: i18n.get(msgCode)
				}).render()
			})
		}
		const row = OrgMultiTreeSelector.prototype.rowTemplate.apply(this, arguments)
		if (ctx.fromTemplate) {
			const deleteButton = row.find('.delete')
			this.syncedItemTooltip = new SyncedItemTooltip({
				el: deleteButton.closest('.synced-item-button'),
				attachTo: deleteButton,
				itemType: i18n.get('common.organization.organization')
			}).render()
			disableCascade('admin.group.organizationPermissions.cascadeDisabled')
		} else {
			let isDisableInfo = ctx.view === false
			let isDisableCascade = ctx.view === false || this.canModifyCascadeViewOrgPermission(ctx) === false

			// https://github.com/SpiderStrategies/Scoreboard/issues/28990#issuecomment-600140657
			// if you cannot disable the cascade, you cannot delete if cascade is checked
			let cannotDeleteBecauseOfCascade = isDisableCascade && ctx.cascade
			let isDisableDelete = !ctx.transient &&
				(ctx.view === false || this.canModifyViewOrgPermission(ctx) === false
				|| cannotDeleteBecauseOfCascade)

			row.find('.info').toggleClass('is-not-displayed', isDisableInfo)
			row.find('.delete').toggleClass('is-not-displayed', isDisableDelete)
			if (isDisableCascade) {
				disableCascade('admin.group.organizationPermissions.cascadeDisabledNoPermission')
			}
		}
		return row
	},

	initItemData: function(treeItem) {
		let item = OrgMultiTreeSelector.prototype.initItemData.apply(this, arguments)
		item.transient = true
		// #28990, if you don't have permission to cascade, then when adding
		// an org, the default cascade value should be false
		item.cascade = this.canModifyCascadeViewOrgPermission(treeItem)
		return item
	},

	shouldShowProjectLabel: function() {
		// Even if the user only has access to 1 project we need to show labels
		// when the group has org permissions that span 2 or more projects (#28950)
		return projects.isVisible() || _.size(this.model.get('projects')) > 1
	},

	getProject: function(projectId) {
		// The user might not have access to view all the projects the group has access
		// to, so for this view we have to read the project info from the response
		// instead of projects.get() (#28950)
		return this._projectsById[projectId] ||
			// But if the group doesn't yet have this project, it must be referenced
			// from the user's (global) list of projects (#28984)
			OrgMultiTreeSelector.prototype.getProject.apply(this, arguments)

	},

	onSubmit: function(cascadeById) {
		// The MultiTreeSelector knows nothing about projects so we have to
		// hydrate all information about each org here so the client can reload
		// the view without fetching new data from the server
		const orgPermissions = _.map(cascadeById, (cascade, id) => {
			return _.assign(this.selectedItemCache[id], {cascade})
		})
		this.model.setOrgPermissions(orgPermissions)
	},

	removeDisabledTooltip: function () {
		this.disabledTooltip && this.disabledTooltip.remove()
		delete this.disabledTooltip
	},

	canModifyViewOrgPermission: function(data) {
		let viewOrgPermissions = this._viewOrgPermissionsByProjectId[this.projectId]
		//check is nil because the data returned is a set of org ids that have the permission
		//thus orgs that DO NOT have the permission are not present so !== false dose not work
		return viewOrgPermissions.maxPermission ||
			!_.isNil(viewOrgPermissions.modifiableViewOrgPermissionOrgIds[data.id])
	},

	canModifyCascadeViewOrgPermission: function(data) {
		let viewOrgPermissions = this._viewOrgPermissionsByProjectId[this.projectId]
		return viewOrgPermissions.maxPermission ||
			!_.isNil(viewOrgPermissions.modifiableCascadeViewOrgPermissionOrgIds[data.id])
	},

	remove: function() {
		OrgMultiTreeSelector.prototype.remove.apply(this, arguments)
		this.removeDisabledTooltip()
		_.invokeMap([this.syncedItemTooltip], 'remove')
	}

})

export default OrgPermissionsForm
export { AdminOrgGardener }
export { getViewOrgPermissions }

OrgPermissionsForm.__filename__ = 'admin/principals/groups/org-permissions-form.js'
